import { useState } from "react";
import { Button, IconButton, Tooltip, TextField, Box, Stack, Grid } from "@mui/material";
import { GridToolbarContainer, gridClasses } from '@mui/x-data-grid';
import SearchIcon from '@mui/icons-material/Search';
import DownloadIcon from '@mui/icons-material/Download';
import AddIcon from '@mui/icons-material/Add';
import { styled, alpha } from '@mui/material/styles';
import { useSelector } from "react-redux";
import {policiesAction} from "../../../const/policies"
import { checkPolicy } from "../../../functions/checkPolicy";

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25)
  },
  marginRight: theme.spacing(2),
  marginLeft: 'auto',
  color: '#3e6bb4'
}));


const TableToolbar = ({startSearch, initialSearchText, enableSearch, downloadXLS, enableExport, handleAdd, enableAdd, typePage }) => {
  const statePolicy = useSelector((state) => state.userDate.policies);
  const [searchText, setSearchText] = useState(initialSearchText);


  return (
    <GridToolbarContainer className={gridClasses.toolbarContainer}>
      <Grid container rowSpacing={2}>
        <Grid item xs={12} sm={9}>
          <Stack direction="row" spacing={2}>
            {enableAdd && checkPolicy(statePolicy, policiesAction.inserimentoModifica, typePage) && (
              <Tooltip title="Aggiungi">
                <Button variant="outlined" startIcon={<AddIcon />} size="small" sx={{color:"#3e6bb4"}} onClick={handleAdd}>
                  Aggiungi
                </Button>
              </Tooltip>
            )}
            {enableExport && checkPolicy(statePolicy, policiesAction.esportazione, typePage) && (
            <Tooltip title="Download file Excel">
              <Button variant="outlined" startIcon={<DownloadIcon />} size="small" sx={{color:"#3e6bb4"}} onClick={downloadXLS}>
                Esporta
              </Button>
            </Tooltip>
          )}
          </Stack>
        </Grid>
        <Grid item xs={12} sm={3}>
          {enableSearch &&
            <Search>
              <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                <Tooltip title="Cerca">
                  <IconButton sx={{color: 'inherit', padding: 0}}
                              onClick={() => {
                                startSearch(searchText);
                              }}
                  >
                    <SearchIcon sx={{ mr: 1, my: 0.5 }}/>
                  </IconButton>
                </Tooltip>
                <TextField id="search-input"
                          placeholder="Cerca..."
                          inputProps={{ 'aria-label': 'search' }}
                          value={searchText}
                          variant="standard"
                          fullWidth
                          onChange={(event) => {
                            setSearchText(event.target.value);
                          }}
                          onBlur={() => {
                            startSearch(searchText);
                          }}
                          onKeyPress={(event) => {
                              if(event.key === 'Enter'){
                                startSearch(searchText);
                              }
                          }}
                  />
              </Box>
            </Search>
          }
        </Grid>
      </Grid>      
    </GridToolbarContainer>
  );

}

export default TableToolbar;